module.exports = "/fonts/nucleo-icons.woff2?ff208b8d733e61a630992ee2b72c9c1c";